/* document */
import { Date } from '../../Form/Inputs/Date.js';
import { Text } from '../../Form/Inputs/Text.js';
import { Textarea } from '../../Form/Inputs/Textarea.js';
import { Hidden } from '../../Form/Inputs/Hidden.js';

export const History = (props) => {
    const { el } = props;
    return (
        <>
            <Date name="created" value={el ? el.created : ''} />
            <Text name="title" value={el ? el.title : ''} />
            <Textarea name="description" value={el ? el.description : ''} />
            <Hidden name="id" value={el ? el.id : ''} />
        </>
    )
}